import AccountOutlined from './AccountOutlined';
import Activities from './Activities';
import Add from './Add';
import AddCircleOutlined from './AddCircleOutlined';
import Archive from './Archive';
import ArrowBack from './ArrowBack';
import Audio from './Audio';
import BellFilled from './BellFilled';
import BlankCalendarOutlined from './BlankCalendarOutlined';
import BookFilled from './BookFilled';
import BookHalfFilled from './BookHalfFilled';
import BookmarkFilled from './BookmarkFilled';
import BookmarkOutlined from './BookmarkOutlined';
import BookOutlined from './BookOutlined';
import CalendarOutlined from './CalendarOutlined';
import CardView from './CardView';
import CaretDown from './CaretDown';
import CaretUp from './CaretUp';
import CircleOutline from './CircleOutline';
import CircleInprogressOutline from './CircleInprogressOutline';
import CircleNotStartedOutline from './CircleNotStartedOutline';
import CheckCircleFilled from './CheckCircleFilled';
import ChevronDown from './ChevronDown';
import ChevronLeft from './ChevronLeft';
import ChevronRight from './ChevronRight';
import ChevronUp from './ChevronUp';
import ClockOutlined from './ClockOutlined';
import Close from './Close';
import Copy from './Copy';
import Collapse from './Collapse';
import CollapseControl from './CollapseControl';
import CollapseMojo from './CollapseMojo';
import CollapseMojoAudio from './CollapseMojoAudio';
import Correct from './Correct';
import Delete from './Delete';
import Descending from './Descending';
import Document from './Document';
import DoublePage from './DoublePage';
import Download from './Download';
import Downloading from './Downloading';
import DrawerClose from './DrawerClose';
import DrawerLeft from './DrawerLeft';
import Edit from './Edit';
import Email from './Email';
import Expand from './Expand';
import ExpandControl from './ExpandControl';
import ExpandMojo from './ExpandMojo';
import ExpandMojoAudio from './ExpandMojoAudio';
import Figure from './Figure';
import Filter from './Filter';
import FilterOptions from './FilterOptions';
import FlagOutlined from './FlagOutlined';
import FlashcardOutlined from './FlashcardOutlined';
import Folder from './Folder';
import Font from './Font';
import FontChange from './FontChange';
import FullscreenOff from './FullscreenOff';
import FullscreenOn from './FullscreenOn';
import Globe from './Globe';
import Grid from './Grid';
import Home from './Home';
import HelpOutlined from './HelpOutlined';
import HelpFilled from './HelpFilled';
import Image from './Image';
import Information from './Information';
import KeyTakeaway from './KeyTakeaway';
import LaunchOutlined from './LaunchOutlined';
import LineSpacingDefault from './LineSpacingDefault';
import LineSpacingWide from './LineSpacingWide';
import LineSpacingWider from './LineSpacingWider';
import Links from './Links';
import ListBulleted from './ListBulleted';
import Listen from './Listen';
import ListView from './ListView';
import Lock from './Lock';
import LockOnOutlined from './LockOnOutlined';
import Menu from './Menu';
import MessageOutlined from './MessageOutlined';
import Misc from './Misc';
import MoreVert from './MoreVert';
import Navigation from './Navigation';
import NewPreference from './NewPreference';
import Notebook from './Notebook';
import Notes from './Notes';
import Pause from './Pause';
import Pdf from './Pdf';
import PearsonLogoMojo from './PearsonLogoMojo';
import PearsonLogo from './PearsonLogo';
import Play from './Play';
import Preview from './Preview';
import PunchHoleLock from './PunchHoleLock';
import Quizzes from './Quizzes';
import Remove from './Remove';
import RemoveCircleOutlined from './RemoveCircleOutlined';
import ResourcesNav from './ResourcesNav';
import ResourcesNavFilled from './ResourcesNavFilled';
import Right from './Right';
import ScoreOutlined from './ScoreOutlined';
import Search from './Search';
import Select from './Select';
import Settings from './Settings';
import ShowOffOutlined from './ShowOffOutlined';
import ShowOnOutlined from './ShowOnOutlined';
import SinglePage from './SinglePage';
import Skill from './Skill';
import SmallCircleFilled from './SmallCircleFilled';
import SmallCircleHalfFilled from './SmallCircleHalfFilled';
import SmallCircleOutline from './SmallCircleOutline';
import Social from './Social';
import Sortable from './Sortable';
import SparkLab from './SparkLab';
import StarFilled from './StarFilled';
import StarHalfFilled from './StarHalfFilled';
import StarOutline from './StarOutline';
import Study from './Study';
import StudyIcon from './StudyIcon';
import Text from './Text';
import Upload from './Upload';
import Video from './Video';
import Warning from './Warning';
import WebLinks from './WebLinks';
import ZippedFiles from './ZippedFiles';
import ZoomIn from './ZoomIn';
import ZoomOut from './ZoomOut';

/**
 * A Map containing all Icons
 * @author Hari Gangadharan
 */
const icons = new Map([
  ['AccountOutlined', AccountOutlined],
  ['Activities', Activities],
  ['Add', Add],
  ['AddCircleOutlined', AddCircleOutlined],
  ['Archive', Archive],
  ['ArrowBack', ArrowBack],
  ['Audio', Audio],
  ['BellFilled', BellFilled],
  ['BlankCalendarOutlined', BlankCalendarOutlined],
  ['BookFilled', BookFilled],
  ['BookHalfFilled', BookHalfFilled],
  ['BookmarkOutlined', BookmarkOutlined],
  ['BookmarkFilled', BookmarkFilled],
  ['BookOutlined', BookOutlined],
  ['CalendarOutlined', CalendarOutlined],
  ['CardView', CardView],
  ['CaretDown', CaretDown],
  ['CaretUp', CaretUp],
  ['CheckCircleFilled', CheckCircleFilled],
  ['ChevronDown', ChevronDown],
  ['ChevronLeft', ChevronLeft],
  ['ChevronRight', ChevronRight],
  ['ChevronUp', ChevronUp],
  ['CircleOutline', CircleOutline],
  ['CircleInprogressOutline', CircleInprogressOutline],
  ['CircleNotStartedOutline', CircleNotStartedOutline],
  ['ClockOutlined', ClockOutlined],
  ['Close', Close],
  ['Copy', Copy],
  ['Collapse', Collapse],
  ['CollapseControl', CollapseControl],
  ['CollapseMojo', CollapseMojo],
  ['CollapseMojoAudio', CollapseMojoAudio],
  ['Correct', Correct],
  ['Delete', Delete],
  ['Descending', Descending],
  ['Document', Document],
  ['DoublePage', DoublePage],
  ['Download', Download],
  ['Downloading', Downloading],
  ['DrawerClose', DrawerClose],
  ['DrawerLeft', DrawerLeft],
  ['Expand', Expand],
  ['ExpandControl', ExpandControl],
  ['ExpandMojo', ExpandMojo],
  ['ExpandMojoAudio', ExpandMojoAudio],
  ['Edit', Edit],
  ['Email', Email],
  ['Figure', Figure],
  ['Filter', Filter],
  ['FilterOptions', FilterOptions],
  ['FlagOutlined', FlagOutlined],
  ['FlashcardOutlined', FlashcardOutlined],
  ['Folder', Folder],
  ['Font', Font],
  ['FontChange', FontChange],
  ['FullscreenOff', FullscreenOff],
  ['FullscreenOn', FullscreenOn],
  ['Globe', Globe],
  ['Grid', Grid],
  ['Home', Home],
  ['HelpFilled', HelpFilled],
  ['HelpOutlined', HelpOutlined],
  ['Image', Image],
  ['Information', Information],
  ['KeyTakeaway', KeyTakeaway],
  ['LaunchOutlined', LaunchOutlined],
  ['LineSpacingDefault', LineSpacingDefault],
  ['LineSpacingWide', LineSpacingWide],
  ['LineSpacingWider', LineSpacingWider],
  ['Links', Links],
  ['ListBulleted', ListBulleted],
  ['Listen', Listen],
  ['ListView', ListView],
  ['Lock', Lock],
  ['LockOnOutlined', LockOnOutlined],
  ['Menu', Menu],
  ['MessageOutlined', MessageOutlined],
  ['Misc', Misc],
  ['MoreVert', MoreVert],
  ['Navigation', Navigation],
  ['NewPreference', NewPreference],
  ['Notebook', Notebook],
  ['Notes', Notes],
  ['PearsonLogoMojo', PearsonLogoMojo],
  ['Pause', Pause],
  ['Pdf', Pdf],
  ['PearsonLogo', PearsonLogo],
  ['Play', Play],
  ['Preview', Preview],
  ['PunchHoleLock', PunchHoleLock],
  ['Quizzes', Quizzes],
  ['Remove', Remove],
  ['RemoveCircleOutlined', RemoveCircleOutlined],
  ['ResourcesNav', ResourcesNav],
  ['ResourcesNavFilled', ResourcesNavFilled],
  ['Right', Right],
  ['ScoreOutlined', ScoreOutlined],
  ['Search', Search],
  ['Select', Select],
  ['Settings', Settings],
  ['ShowOffOutlined', ShowOffOutlined],
  ['ShowOnOutlined', ShowOnOutlined],
  ['SinglePage', SinglePage],
  ['Skill', Skill],
  ['SmallCircleFilled', SmallCircleFilled],
  ['SmallCircleHalfFilled', SmallCircleHalfFilled],
  ['SmallCircleOutline', SmallCircleOutline],
  ['Social', Social],
  ['Sortable', Sortable],
  ['SparkLab', SparkLab],
  ['StarFilled', StarFilled],
  ['StarHalfilled', StarHalfFilled],
  ['StarOutline', StarOutline],
  ['Study', Study],
  ['StudyIcon', StudyIcon],
  ['Text', Text],
  ['Upload', Upload],
  ['Video', Video],
  ['Warning', Warning],
  ['WebLinks', WebLinks],
  ['ZippedFiles', ZippedFiles],
  ['ZoomIn', ZoomIn],
  ['ZoomOut', ZoomOut]
]);

export default icons;
